<template>
  <v-container
    class="pa-0"
    style="height:100%"
  >
    <options-header
      :option="navigationStackLast"
      :can-go-home="navigationStack.length > 1"
      @backClick="goBack"
      @homeClick="goHome"
    />
    <div
      class="scroll"
      :style="scrollStyle"
    >
      <options-list
        v-if="isNavigationStackEmpty"
        :options="options"
        @optionDidSelected="optionDidSelected"
      />
      <options-categories-list
        v-else-if="getCategoriesForOption(navigationStackLast)"
        :categories="getCategoriesForOption(navigationStackLast)"
        @categoryDidSelected="categoryDidSelected"
      />
      <options-items-list
        v-else
        :items="getItemsForOption(navigationStackLast)"
        @itemDidSelected="$emit('optionsItemDidSelected', $event)"
      />
    </div>
  </v-container>
</template>

<script>
  import OptionsHeader from './OptionsHeader.vue'
  import OptionsList from './lists/OptionsList.vue'
  import OptionsCategoriesList from './lists/OptionsCategoriesList.vue'
  import OptionsItemsList from './lists/OptionsItemsList.vue'

  export default {
    name: 'OptionsPanel',

    components: {
      OptionsHeader,
      OptionsList,
      OptionsCategoriesList,
      OptionsItemsList,
    },

    props: {
      options: Array,
    },

    data () {
      return {
        navigationStack: [],
      }
    },

    computed: {
      isNavigationStackEmpty () {
        return (this.navigationStack === undefined || this.navigationStack.length === 0)
      },
      navigationStackLast () {
        return !this.isNavigationStackEmpty ? this.navigationStack[this.navigationStack.length - 1] : null
      },
      scrollStyle () {
        return !this.isNavigationStackEmpty ? 'height:calc(100% - 58px)' : 'height:100%'
      },
    },

    watch: {
      options: function (newOptions, oldOptions) {
        this.sychronizeNavigationStack(newOptions)
      },
    },

    methods: {
      goBack () {
        this.navigationStack.pop()
      },

      goHome () {
        this.navigationStack = []
      },

      optionDidSelected (option) {
        this.navigationStack = [option]
      },

      categoryDidSelected (category) {
        this.navigationStack.push(category)
      },

      itemMouseDidOver (item) {
        console.log('Over ' + item.name)
      },

      itemMouseDidLeave (item) {
        console.log('Leave ' + item.name)
      },

      getCategoriesForOption (option) {
        if (option == null || option === undefined) return null
        else if (option.has_category === true && option.elements) return option.elements
        else if (option.children && option.children.length > 0) return option.children
        else return null
      },

      getItemsForOption (option) {
        if (option.elements && option.elements.length > 0) return option.elements
        else if (option.shades && option.shades.length > 0) return option.shades
        else if (option.accessories && option.accessories.length > 0) return option.accessories
        else return null
      },

      sychronizeNavigationStack (newOptions) {
        if (this.isNavigationStackEmpty) return

        const option = newOptions.find(option => option.id === this.navigationStack[0].id)
        if (!option || option === undefined) {
          this.navigationStack = []
          return
        }
        this.newStack = [option]

        if (this.navigationStack.length > 1) {
          for (let i = 1; i < this.navigationStack.length; i++) {
            const categories = this.getCategoriesForOption(this.newStack[this.newStack.length - 1])
            if (categories) {
              const category = categories.find(category => category.id === this.navigationStack[i].id)
              if (category && category !== undefined) {
                this.newStack.push(category)
              } else {
                break
              }
            } else {
              break
            }
          }
        }

        this.navigationStack = this.newStack
      },
    },
  }
</script>

<style scoped>

.scroll {
  overflow-y: auto;
}

</style>
